import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkAccountComponent } from './link-account.component';
import { NgxMaskModule } from 'ngx-mask';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { LinkAccountRoutingModule } from './link-account-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';

@NgModule({
  declarations: [
    LinkAccountComponent
  ],
  imports: [
    LinkAccountRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    SharedComponentsModule,
    MaterialModule
  ],
  // exports: [MaterialModule]
})
export class LinkAccountModule { }
